import { DocumentListFilter, DocumentListFilterFormData } from '@/models/documents/document-list-filter.model';

type DocumentListFilterExternalIdList = Pick<DocumentListFilter, 'tagIdList' | 'segmentIdList'>;

export const documentListFilterDtoToApi = (
  { tagList, segmentList, ...documentListFilterDto }: DocumentListFilterFormData,
  { tagIdList, segmentIdList }: DocumentListFilterExternalIdList,
): DocumentListFilter => {
  return {
    ...documentListFilterDto,
    tagIdList,
    segmentIdList,
  };
};
